import { List } from 'immutable';
import tr from './translate';

function translateFeature(feature) {
  const translation = tr(`common.features.${feature}`);
  if (new RegExp(feature).test(translation)) {
    return feature;
  }

  return translation;
}

export default function translateFeatureList(features, forCircle = true) {
  const list = Array.isArray(features) ? new List(features) : features;

  if (list.size === 0) {
    if (forCircle) {
      return tr('common.features.no_preference');
    }

    return tr('common.features.nothing');
  } if (list.size === 1) {
    return translateFeature(list.get(0));
  }

  const separator = tr('matching.features.list.general_separator');
  const finalSeparator = tr('matching.features.list.final_separator');

  const translated = list.map(translateFeature);

  return translated.slice(0, -1).join(separator) + finalSeparator + translated.last();
}
